import { createFileRoute } from "@tanstack/react-router";
import { CheckSquare, Bell, Users } from "lucide-react";
import { FeaturePage } from "@/components/marketing/FeaturePage";
import { alternateLinkList } from "@/lib/i18n/locale";
import heroImg from "@/assets/pipelines-tasks-trio.webp";
import workflowImg from "@/assets/pipelines-tasks-create.webp";
import teamImg from "@/assets/pipelines-tasks-board.webp";

export const Route = createFileRoute("/vi/platform/tasks")({
  head: () => ({
    meta: [
      { title: "Task & Lời nhắc — banana.cards" },
      { name: "description", content: "Task gắn vào liên hệ, deal và cuộc họp. Lời nhắc thông minh, SLA và phân chia round-robin." },
      { property: "og:title", content: "Task & Lời nhắc — banana.cards" },
      { property: "og:description", content: "Task gắn vào liên hệ, deal và cuộc họp." },
      { property: "og:image", content: heroImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/tasks", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <FeaturePage
      eyebrow="Task & Lời nhắc"
      title="Không bao giờ"
      italic="bỏ lỡ follow-up."
      description="Task gắn trực tiếp vào liên hệ, deal và cuộc họp. Lời nhắc thông minh, theo dõi SLA và phân chia round-robin — để không ai rơi vào kẽ hở."
      heroImage={heroImg}
      metrics={[{ v: "0", l: "lead bị rơi" }, { v: "auto", l: "lời nhắc" }, { v: "SLA", l: "theo dõi" }]}
      bullets={[
        { icon: CheckSquare, title: "Task có ngữ cảnh", desc: "Mọi task gắn vào liên hệ, deal hoặc cuộc họp — không bao giờ mất ngữ cảnh." },
        { icon: Bell, title: "Lời nhắc thông minh", desc: "Push, email và SMS — đúng người, đúng lúc." },
        { icon: Users, title: "Round-robin", desc: "Tự động phân task giữa thành viên đội — không thiên vị." }
      ]}
      deepDives={[
        { eyebrow: "Tạo nhanh", title: "Task từ mọi nơi,", italic: "trong vài giây.", description: "Tạo task từ liên hệ, deal, cuộc họp hoặc email. AI có thể tạo task từ action items của cuộc gọi.", image: workflowImg, reverse: false, points: ["Tạo task từ AI", "Template task", "Task định kỳ", "Phụ thuộc giữa task"] },
        { eyebrow: "Đội", title: "Board cho đội,", italic: "xem cho cá nhân.", description: "Board kanban cho đội xem mọi thứ, hoặc list cá nhân cho focus. Phân chia thông minh đảm bảo không ai quá tải.", image: teamImg, reverse: true, points: ["Kanban & list view", "Lọc theo người, ngày, tag", "Round-robin với capacity", "Theo dõi SLA và overdue"] }
      ]}
      howItWorks={[
        { title: "Tạo task", desc: "Từ mọi nơi trong Banana." },
        { title: "Gán & deadline", desc: "Cho người và ngày." },
        { title: "Nhận lời nhắc", desc: "Push, email, SMS." },
        { title: "Hoàn thành & log", desc: "Lịch sử trên liên hệ/deal." }
      ]}
      capabilities={["Task có ngữ cảnh", "Lời nhắc đa kênh", "Task định kỳ", "Phụ thuộc giữa task", "Round-robin với capacity", "Theo dõi SLA", "Bulk actions", "Tích hợp lịch"]}
      faq={[
        { q: "Task có gắn vào CRM không?", a: "Có — mọi task gắn vào liên hệ, deal hoặc cuộc họp. Khi mở hồ sơ, bạn thấy mọi task liên quan và lịch sử." },
        { q: "Có thể tạo task tự động từ trigger không?", a: "Có — qua Automations: 'khi deal chuyển sang Won, tạo task onboarding cho account manager'." },
        { q: "Lời nhắc được gửi qua kênh nào?", a: "Push notification, email và SMS. Cấu hình theo task hoặc theo người dùng." },
        { q: "Round-robin hoạt động thế nào?", a: "Banana phân task giữa thành viên đội đủ điều kiện theo lượt — với tùy chọn cân nhắc capacity hiện tại để tránh quá tải." }
      ]}
      outro={{ title: "Mọi follow-up đến nơi.", italic: "Đúng giờ.", description: "Task biến intent thành kết quả." }}
    />
  );
}